module.exports = __webpack_public_path__ + "img/30732777378_2289090983_w.208ddf91.jpg";